import PopularTopicsStats from './PopularTopicsStats';
import TopContributorsStats from './TopContributorsStats';
import TotalUsers from './TotalUsers';
import UsersByCompanyAffiliation from './UsersByCompanyAffiliation';
import UsersByCountry from './UsersByCountry';
import UsersByCountryInsight from './UsersByCountryInsight';
import UsersByPurpose from './UsersByPurpose';
import UsersByRegion from './UsersByRegion';

function UsersGraphs() {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <TotalUsers />
      <UsersByRegion />
      <UsersByCountry />
      <UsersByCountryInsight />
      <UsersByCompanyAffiliation />
      <PopularTopicsStats />
      <TopContributorsStats />
      <UsersByPurpose />
    </div>
  );
}

export default UsersGraphs;
